import { processStatusEnum } from "@/types/entities/process";

/**
 * Get the badge color for a process status.
 *
 * @param status - process status
 * @returns badge color
 */
export const getStatusBadgeColor = (
  status?: string,
): "success" | "neutral" | "action" => {
  let statusColor: "success" | "neutral" | "action" = "neutral";
  if (status === processStatusEnum.active) statusColor = "success";
  else if (status === processStatusEnum.inactive) statusColor = "neutral";
  else if (status === processStatusEnum.onConstruction) statusColor = "action";
  return statusColor;
};
